import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { PinRendererProps } from './pinMediaRenderer';
import { hostOf, withScheme } from './pinMediaUrl';

export function WebLinkPin({ pin }: PinRendererProps) {
  const { t } = useTranslation('patterns', { keyPrefix: 'PinMedia' });
  const label =
    pin.pin_type === 'github/repo'
      ? t('githubRepo')
      : pin.pin_type === 'medium/post'
        ? t('mediumPost')
        : t('website');
  return (
    <a
      href={withScheme(pin.url)}
      target="_blank"
      rel="noopener noreferrer"
      className="flex w-80 max-w-full flex-col gap-2 rounded-xl bg-bg-subtle p-6 hover:bg-bg-inset"
    >
      <span className="flex items-center justify-between gap-3 text-xs font-semibold uppercase text-fg-muted">
        {label}
        <ExternalLink className="size-4" aria-hidden />
      </span>
      <span className="truncate text-base text-fg-default">
        {hostOf(pin.url)}
      </span>
    </a>
  );
}
